import axios from 'axios'
import { host } from '../../helper/config'
import { ITEM_PER_PAGE } from '../../helper/helper'

const PLUGINS_NAME = 'admin-devices'

export const getAllDevices = async (token, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-all`, {
        page: page,
        itemPerPage: ITEM_PER_PAGE
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const getDevicesForSelect = async (token) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-all`, {
        page: 0,
        itemPerPage: 1000
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return (response.data && response.data.data) || []
    }
    return []
}

export const update = async (token, id, name, code, status) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update`, {
        id: id,
        name: name,
        code: code,
        status: status
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const add = async (token, code, name) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/add`, {
        code: code,
        name: name
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const deleteDevice = async (token, id) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/delete`, {
        id: id
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}